import React, { Component } from "react";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PeopleCard from "../../../components/PeopleCard";

import { withTranslation } from "react-i18next";
import i18n from "../../../i18n";
import AuthService from "../../../session/AuthService";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";

const styleArrow = {
  width: 36,
  height: 36,
  boxShadow: "0px 3px 6px #00000029",
  border: "1px solid #DEDEDF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#fff",
  borderRadius: "100%",
  cursor: "pointer",
  position: "absolute",
  top: "40%",
  zIndex: 10,
};
function NextArrow(props) {
  const { className, style, onClick, currentSlide, slideCount } = props;
  return currentSlide !== slideCount - 2 ? (
    <div style={{ ...styleArrow, right: "-1%" }} onClick={onClick}>
      <ArrowForwardIcon />
    </div>
  ) : (
    <></>
  );
}

function PrevArrow(props) {
  const { className, style, onClick, currentSlide } = props;
  return currentSlide >= 0 ? (
    <div style={{ ...styleArrow, left: "-5%" }} onClick={onClick}>
      <ArrowBackIcon />
    </div>
  ) : (
    <></>
  );
}
class PeoplesCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recommendedFriendsList: [],
      recommendedFriendsListState: false,
    };
    this.getRecommendedFriendsList = this.getRecommendedFriendsList.bind(this);
    this.requestSentPage = this.requestSentPage.bind(this);
    this.gotoSuggestedFriendsList = this.gotoSuggestedFriendsList.bind(this);
    this.ignoreSentPage = this.ignoreSentPage.bind(this);
  }

  componentDidMount() {
    this.getRecommendedFriendsList(
      this.props.recommended_friends_list,
      this.props.recommendedListLength
    );
    let langValue = AuthService.getCommonLanguages();
    i18n.changeLanguage(langValue);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.recommended_friends_list !== this.props.recommended_friends_list
    ) {
      this.getRecommendedFriendsList(
        this.props.recommended_friends_list,
        this.props.recommendedListLength
      );
    }
  }

  render() {
    const { t } = this.props;
    const settings = {
      infinite: false,
      slidesToShow: 3,
      speed: 500,
      arrows: true,
      draggable: true,
      dots: false,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      responsive: [
        {
          breakpoint: 1240,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            draggable: true,
            dots: false,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: true,
            draggable: true,
            dots: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            draggable: true,
            dots: false,
          },
        },
      ],
    };
    return (
      <div className="peopleCarouselWrapper ">
        <div className="searchHeading flexDefault flexAlignCenter flexJustifySpacebetween">
          {/* <div>
            <p className="boldLabel">{t("")}</p>
          </div> */}
          {/* <h3
            className="listHomeTitle"
            style={{  marginTop: "12px" }}
          >
            Suggested Connections
          </h3> */}
          {/* <div
            style={{ cursor: "pointer", display: "inline-flex" }}
            onClick={this.gotoSuggestedFriendsList}
          >
            <button onClick={() => this.gotoSuggestedFriendsList}>
              {t("See all")}
            </button>
          </div> */}
        </div>

        {/* <Grid container spacing={2}> */}
        {/* <Slider {...settings} className=""> */}
        <Grid container spacing={2}>
          {!this.state.recommendedFriendsListState &&
            this.state.recommendedFriendsList.map((people, index) => {
              return (
                <Grid item xs={12} sm={12} md={3} lg={3} key={index}>
                  <React.Fragment key={index}>
                    <PeopleCard
                      userId={people.uId}
                      name={`${people.fName} ${people.lName}`}
                      Dname={people.dName}
                      userName={people.userName}
                      country={
                        people.countryName !== null
                          ? people.countryName
                          : "--------"
                      }
                      nameLocation={
                        people.location != null ? people.location : "--------"
                      }
                      profession={
                        people.professionName != null
                          ? people.professionName
                          : "--------"
                      }
                      //   subjects={people.user.userLearn}
                      tagsValue={
                        people.tagsValue.length !== 0
                          ? people.tagsValue
                          : "---------"
                      }
                      requestSent={this.requestSentPage}
                      ignoreSent={this.ignoreSentPage}
                      searchData={this.props.searchData}
                      coverPhoto={people.coverPhoto}
                      profilePhoto={people.profilePhoto}
                      premiumData={people?.premiumData}
                    />
                  </React.Fragment>
                </Grid>
              );
            })}
        </Grid>
        {/* </Slider>   */}
        {/* </Grid> */}
      </div>
    );
  }

  ignoreSentPage() {
    this.props.ignoreSentPageData();
  }

  requestSentPage(e) {
    // alert(e)
    this.props.requestSentPageData(e, "recommend");
  }

  async getRecommendedFriendsList(
    recommended_friends_list,
    recommendedListLength
  ) {
    if (recommended_friends_list.length > 0) {
      await this.setState({
        recommendedFriendsList: recommended_friends_list,
        recommendedFriendsListState: false,
        recommendedListLengths: recommendedListLength,
      });
    } else {
      await this.setState({
        recommendedFriendsListState: true,
        recommendedListLengths: recommendedListLength,
      });
    }
  }

  gotoSuggestedFriendsList() {
    this.props.history.push({
      pathname: "/suggested-friends-list",
    });
  }
}

export default withTranslation()(withRouter(PeoplesCarousel));
